module.exports = __webpack_public_path__ + "static/media/Satish-Ramchandani.72bd7a88.svg";